import { useEffect, useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import { useDispatch } from "react-redux";
import { isEqual } from "lodash";
import {
  deleteTag,
  getTagList,
  updateTag,
} from "../../actionCreator/dashboardActionCreator";
import { useAlert } from "../../context/AlertProvider";
import { getClientNotesTags } from "../../actionCreator/leadDetailsActionCreator";

const EditDeleteTag = ({ isOpen, handleCancel, data, userId }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { showAlert } = useAlert();
  const isDelete = data?.type.includes("delete");
  const [isChanged, setIsChanged] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    const res = await dispatch(deleteTag(data?.data?.id));

    if (res?.status === 204) {
      showAlert("success", "Tag deleted successfully.");

      if (data?.data?.type === "NOTE") {
        dispatch(getClientNotesTags(userId));
      } else {
        dispatch(getTagList(data?.data?.type, userId));
      }
    } else {
      showAlert("error", res?.response?.data?.title);
    }
    setLoading(false);
    form.resetFields();
    handleCancel();
  };

  const onFinish = async (values) => {
    setLoading(true);
    const res = await dispatch(
      updateTag({ id: data?.data?.id, ...values, type: data?.data?.type }),
    );

    if (res?.status === 200) {
      showAlert("success", "Tag updated successfully.");
      if (data?.data?.type === "NOTE") {
        dispatch(getClientNotesTags(userId));
      } else {
        dispatch(getTagList(data?.data?.type, userId));
      }
    } else {
      showAlert("error", res?.response?.data?.title);
    }
    setLoading(false);
    form.resetFields();
    handleCancel();
  };

  useEffect(() => {
    form.setFieldsValue({ ...data?.data });
  }, [data, form]);

  return (
    <Modal
      title={null}
      open={isOpen}
      width={400}
      className="delete-popup"
      centered
      footer={null}
      onCancel={() => {
        form.resetFields();
        handleCancel();
      }}
    >
      <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
        {isDelete ? "Delete" : "Update"} Tag
      </div>
      <div>
        {isDelete ? (
          <>
            <div className="tw-m-4">
              Are you sure you want to remove the tag "{data?.data?.name}"? This
              will not delete the entities but just untag them.
            </div>
            <div className="tw-flex tw-bg-secondary-color tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-4">
              <Button
                className="tw-border-sub-text hover:!tw-border-sub-text tw-text-sm tw-text-sub-text hover:!tw-text-sub-text"
                onClick={() => {
                  form.resetFields();
                  handleCancel();
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                loading={loading}
                disabled={loading}
                className="stop-sync"
                onClick={() => {
                  handleDelete();
                }}
              >
                Delete
              </Button>
            </div>
          </>
        ) : (
          <Form
            form={form}
            initialValues={data?.data}
            layout="vertical"
            onFinish={onFinish}
            onChange={(currentValues) => {
              const changed = !isEqual(currentValues, {
                text: data?.data?.text,
              });
              setIsChanged(changed);
            }}
          >
            <div className="tw-m-4">
              <Form.Item
                label={<label className="fw-semibold">Tag Name</label>}
                name="name"
                rules={[{ required: true, message: "Please enter tag name" }]}
              >
                <Input placeholder="Enter tag name" />
              </Form.Item>
            </div>
            <div className="tw-flex tw-bg-secondary-color tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-4">
              <Button
                className="tw-border-sub-text hover:!tw-border-sub-text tw-text-sm tw-text-sub-text hover:!tw-text-sub-text"
                onClick={() => {
                  form.resetFields();
                  handleCancel();
                }}
              >
                Cancel
              </Button>
              <Button
                loading={loading}
                type="primary"
                className="!tw-bg-theme tw-font-medium !tw-outline-0 !tw-border-theme !tw-text-white tw-font-medium tw-text-sm"
                htmlType="submit"
                disabled={!isChanged || loading}
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </div>
    </Modal>
  );
};

export default EditDeleteTag;
